<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <div align="center">
      <p>确定删除商品信息</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">点错了</el-button>
      <el-button type="primary" @click="deleteProductStock">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteProductStock } from '@/api/goods/productStockApi'

export default {
  name: 'DeleteProductStock',
  data() {
    return {
      dialogVisible: false,
      deleteProductStockInfo: {}
    }
  },
  methods: {
    open(product) {
      this.deleteProductStockInfo = product
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    },
    async deleteProductStock() {
      try {
        const res = await deleteProductStock(this.deleteProductStockInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error(error)
      }
    }
  }
}
</script>